module.exports = __webpack_public_path__ + "static/media/2 4 horsemen of the apocalypse chestpiece tattoo black and grey.1280x1238.0d4f2009.webp";